import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import CreateOutcomeCode from './CreateOutcomeCode';
import LoadingPageText from '../../../common/Loading/LoadingPageText';
import { useFetchOutcomeCodes } from '../../../../actions/areas/admin/fetchHooks/fetchExternalProvider';
import { tableSettings } from './outcomeCodesTableSettings';
import { eventHandlers } from './outcomeCodesHandler';
import globals from '../../../../globals/communityGlobals';

const locale = globals.getAreas(['userActions', 'externalProvider']);

export default function OutcomeCodesPage() {
  const [state, setState] = useState({ forceReload: false, openAddCodePanel: false });
  const [serverErrorMsg, setServerErrorMsg] = useState('');
  const { data, isDataLoading, auth, isTableDataLoading } = useFetchOutcomeCodes(state.forceReload);

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>
        {locale.getMsg('loadingMsg', [locale.getMsg('outcomeCodes')])}
      </LoadingPageText>
    );

  const events = eventHandlers(state, setState, setServerErrorMsg, auth);
  const settings = tableSettings({ eventHandlers: events, isTableDataLoading });

  return (
    <div className="page-content-wrapper">
      <MUIDataTable title={settings.name} data={data} columns={settings.columns} options={settings.options} />
      {state.openAddCodePanel && <CreateOutcomeCode events={events} serverErrorMsg={serverErrorMsg} />}
    </div>
  );
}
